export default "__VITE_ASSET__CGgnwfmB__"